import {cartApi, cartData} from "./../cart-api/cart-api"
import {rerenderCartDropdown} from "./cart-dropdown--rerender";

export const initCartSingle = () => {
  const dropdowns = document.querySelectorAll(".i-cart-overview")

  dropdowns.forEach((dropdown) => {
    const items = dropdown.querySelectorAll<HTMLElement>(".i-product-overview, .i-coupon")

    items.forEach((item) => {
      const deleteButton = item.querySelector<HTMLElement>(".--js-cart-overview-remove")
      const counterInput = item.querySelector<HTMLInputElement>(".c-counter__input")
      const productId = item.dataset.productId ?? null
      const mass = item.dataset.mass ?? null

      counterInput?.addEventListener("change", async () => {
        if (!productId) {
          console.log("product id is missing")
          return
        }

        const quantity = Number(counterInput.value)

        const cartItemCounter = document.querySelector<HTMLInputElement>(`.--js-cart-counter[data-product-id="${productId}"] .c-counter__input`)

        if (cartItemCounter) {
          cartItemCounter.value = quantity.toString();
          cartItemCounter.dispatchEvent(new Event("change"))
        }

        const response = await cartApi.change(productId, mass, quantity)

        if (response.ok) {
          const data = (await response.json()) as cartData

          if (!data.success) {
            item.classList.remove("--loading")
            return
          }

          rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)
        }

        item.classList.remove("--loading")
      })

      deleteButton?.addEventListener("click", async () => {
        if (!productId) {
          console.log("product id is missing")
          return
        }

        const cartItemButton = document.querySelector<HTMLElement>(`.--js-cart-remove[data-product-id="${productId}"]`)

        if (cartItemButton) {
          cartItemButton.dispatchEvent(new Event("click"))
          return
        }

        item.classList.add("--loading")

        const response = await cartApi.delete(productId, mass)

        if (response.ok) {
          const data = (await response.json()) as cartData

          if (!data.success) {
            item.classList.remove("--loading")
            return
          }

          item.classList.remove("--loading")

          rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)
        }
      })
    })
  })
}
initCartSingle()
